import { useEffect, useRef, useState } from 'react'
import { supabase } from '../../lib/supabase'
import { useMyCompanies } from '../../hooks/useMyCompanies'

export default function CompanySwitcher({ onDark = false }: { onDark?: boolean }) {
  const { companies, activeCompanyId, loading } = useMyCompanies()
  const [open, setOpen] = useState(false)
  const [switching, setSwitching] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false)
    }
    document.addEventListener('mousedown', onClick)
    return () => document.removeEventListener('mousedown', onClick)
  }, [])

  // Só faz sentido quando o usuário pertence a mais de uma empresa.
  if (loading || companies.length <= 1) return null

  const active = companies.find(c => c.companyId === activeCompanyId)

  const select = async (companyId: string) => {
    if (companyId === activeCompanyId || switching) { setOpen(false); return }
    setSwitching(true)
    const { error } = await supabase.rpc('switch_active_company', { p_company_id: companyId })
    if (error) { setSwitching(false); setOpen(false); return }
    window.location.reload()
  }

  return (
    <div ref={ref} className="relative shrink-0">
      <button
        onClick={() => setOpen(o => !o)}
        disabled={switching}
        className={`flex items-center gap-1.5 px-2 sm:px-3 py-1.5 disabled:opacity-50 rounded-lg text-xs transition-colors max-w-[160px] ${onDark ? 'bg-white/10 hover:bg-white/20 text-white/90' : 'bg-sunken hover:bg-line text-ink-muted'}`}
        title="Trocar de empresa"
      >
        <span className="truncate">{active?.name ?? 'Empresa'}</span>
        <span className={onDark ? 'text-white/60' : 'text-ink-faint'}>▾</span>
      </button>
      {open && (
        <div className="absolute right-0 mt-1 w-56 bg-surface border border-line rounded-lg shadow-xl py-1 z-50">
          {companies.map(c => (
            <button
              key={c.companyId}
              onClick={() => select(c.companyId)}
              className={`w-full text-left px-3 py-2 text-xs hover:bg-sunken transition-colors ${
                c.companyId === activeCompanyId ? 'text-brand-400 font-semibold' : 'text-ink-muted'
              }`}
            >
              {c.name}
              {c.companyId === activeCompanyId && <span className="ml-2 text-ink-faint">(atual)</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
